import React, {FC, LegacyRef, memo} from "react"
import {useIsOnClient} from "../../../../hooks/useIsOnClient"
import {SwiperCarousel} from "../../components/SwiperCarousel"
import {SlideDetail} from "../../helpers"
import {TextModel} from "../../../../models/Text"
import {MobileThumbnailConfig} from "../../../../models/ProductSummary"

interface SwiperColourwayImageProps {
    slides: SlideDetail[]
    currentSlideIndex: number
    text: TextModel
    textAlignment: string
    colourchipSelected: number
    mobileThumbnailConfig: MobileThumbnailConfig
    fetchAdditionalColourchipsThunk: () => void
    emblaRef: LegacyRef<HTMLDivElement> | undefined
    lazyloadProductImages: boolean
}

export const StandardSwiperColourwayImages: FC<SwiperColourwayImageProps> = memo(props => {
    const {isOnClient} = useIsOnClient()
    return <SwiperCarousel {...props} isOnServer={!isOnClient} />
})

StandardSwiperColourwayImages.displayName = "StandardSwiperColourwayImages"

export default StandardSwiperColourwayImages
